/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：832
 */

var r = require(/* 1583 */"./1583")
module.exports = function (e, t) {
  return new (r(e))(0 === t ? 0 : t)
}
